/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { actions } = store('acf/nav-mega-menu-group', {
	
	// actions: {
	// 	toggleMenu() {
			
	// 		//actions.clearAll(); //clear all buttons aria-expanded state to false

	// 		const context = getContext();
	// 		context.isMenuOpen = !context.isMenuOpen;
	// 		console.log('what clicked', getElement())
	// 		// if (context.isMenuOpen === true) {
	// 		// 	console.log('closing menu')
	// 		// 	actions.closeMenu();
	// 		// } else {
	// 		// 	console.log('opening menu')
	// 		// 	context.isMenuOpen = true;
	// 		// }
	// 	},
	// 	openMenuOnHover() {
	// 		// actions.clearAll();
	// 		const context = getContext();
	// 		// context.submenuOpenedBy.hover = true;
	// 		context.isMenuOpen = true;
	// 	},
	// 	closeMenuOnHover() {
	// 		// actions.clearAll();
	// 		const context = getContext();
	// 		// context.submenuOpenedBy.hover = false;
	// 		context.isMenuOpen = false;
	// 	},
	// 	handleMenuKeydown(event) {
	// 		if (event.key === 'Escape') {
	// 			const context = getContext();
	// 			context.isMenuOpen = false;
	// 			console.log('escape pressed')
	// 		}
	// 	},
	// 	clearAll() {
	// 		console.log('clearing all')
	// 		const allButtonsInMenuGroup = document.querySelectorAll('.wp-block-acf-nav-mega-menu-group__button');
	// 		for (const button of allButtonsInMenuGroup) {
				
	// 			//clear all buttons aria-expanded state to false when toggling the menu.
	// 			button.setAttribute('aria-expanded', 'false')
				
	// 		}

	// 	}
	// }
} );